import React from 'react';
import { Helmet } from 'react-helmet';

interface MetaProps {
  title: string;
  websiteTitle?: string;
}

const Meta = ({
  title,
  websiteTitle = 'CareSignal'
}: MetaProps): JSX.Element => {
  return (
    <Helmet>
      <title>
        {title} | {websiteTitle}
      </title>
    </Helmet>
  );
};

export default Meta;
